import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { KeyRound, LogIn } from "lucide-react";
import { useState, type FormEvent } from "react";
import { useAuth } from "../auth/AuthContext";

export const Route = createFileRoute("/login")({
  component: LoginPage,
});

function LoginPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await auth.login(email, password);
      await navigate({ to: "/admin" });
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Could not sign in.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="auth-page">
      <form className="auth-card" onSubmit={submit}>
        <span className="auth-icon">
          <KeyRound aria-hidden="true" />
        </span>
        <p className="eyebrow">Private administration</p>
        <h1>Kirtan Finder</h1>
        <p>Sign in with an account created by the administrator.</p>
        <label>
          <span>Email</span>
          <input
            type="email"
            autoComplete="username"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </label>
        <label>
          <span>Password</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </label>
        {error && (
          <div className="auth-error" role="alert">
            {error}
          </div>
        )}
        <button type="submit" disabled={submitting}>
          <LogIn aria-hidden="true" />
          {submitting ? "Signing in…" : "Sign in"}
        </button>
        <Link to="/">Back to the books</Link>
      </form>
    </main>
  );
}
